// extracted by mini-css-extract-plugin
export default {"seperator":"NoDimension_seperator__kkKAU","nodimension_container":"NoDimension_nodimension_container__ID4K6"};